import React, {useEffect, useState} from 'react'
import { useD3 } from '../../hooks/useD3';
import * as d3 from 'd3'

function Barchart({ data, xAxisProp, yAxisProp, seriesProp }) {
  const ref = useD3(
    (svg) => {
      const height = 500;
      const width = 500;
      const margin = { top: 20, right: 30, bottom: 30, left: 40 };

      // const x = d3
      //   .scaleBand()
      //   .domain(data.map((d) => d[xAxisProp]))
      //   .rangeRound([margin.left, width - margin.right])
      //   .padding(0.1);
      // const x = d3
      //   .scaleTime()
      //   .domain(d3.extent(data.map( d => d[xAxisProp] )))
      //   .nice()
      //   .rangeRound([margin.left, width - margin.right])
        const color = d3.scaleOrdinal(d3.schemeCategory10)
        const x = d3
        .scaleBand()
        .domain(data.map( d => d[xAxisProp] ))
        .rangeRound([margin.left, width - margin.right])

      console.log("domain", x.domain())
      console.log("range", x.range())


      const y1 = d3
        .scaleLinear()
        .domain([0, d3.max(data, (d) => d[yAxisProp])])
        .rangeRound([height - margin.bottom, margin.top])


      const xAxis = (g) =>
        g.attr("transform", `translate(0,${height - margin.bottom})`).call(
          d3
            .axisBottom(x)
            .ticks(5)
        );

      const y1Axis = (g) =>
        g
          .attr("transform", `translate(${margin.left},0)`)
          .style("color", "steelblue")
          .call(d3.axisLeft(y1).ticks(null, "s"))
          .call((g) => g.select(".domain").remove())
          .call((g) =>
            g
              .append("text")
              .attr("x", -margin.left)
              .attr("y", 10)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
              .text(data.y1)
          );

      svg.select(".x-axis").call(xAxis);
      svg.select(".y-axis").call(y1Axis);

      svg
        .select(".plot-area")
        .attr("fill", "steelblue")
        .selectAll(".bar")
        .data(data)
        .join("rect")
        .attr("class", "bar")
        .attr("fill", (d) => color(d[seriesProp]) )
        .attr("x", (d) => x(d[xAxisProp]))
        .attr("width", (width - (margin.left + margin.right)) / data.length - 1)
        .attr("y", (d) => y1(d[yAxisProp]))
        .attr("height", (d) => y1(0) - y1(d[yAxisProp]));
    },
    [data.length]
  );

  return (
    <svg
      ref={ref}
      style={{
        height: 500,
        width: 500,
        marginRight: "0px",
        marginLeft: "0px",
      }}
    >
      <g className="plot-area" />
      <g className="x-axis" />
      <g className="y-axis" />
    </svg>
  );
}

export default Barchart